import React from 'react'

export const googlemap = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="84"
    height="85"
    viewBox="0 0 84 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M75.6211 77.9V15.4C75.6211 11.9479 72.8232 9.15002 69.3711 9.15002H6.87109C3.41901 9.15002 0.621094 11.9479 0.621094 15.4V77.9C0.621094 81.3521 3.41901 84.15 6.87109 84.15H69.3711C72.8232 84.15 75.6211 81.3521 75.6211 77.9Z"
      fill="#1C9957"
    />
    <path
      d="M6.87038 84.15H69.3704C72.8225 84.15 38.1204 50.8167 38.1204 50.8167C38.1204 50.8167 3.4183 84.15 6.87038 84.15Z"
      fill="#3E7BF1"
    />
    <path
      d="M75.6224 77.9V15.4C75.6224 11.948 42.2891 46.65 42.2891 46.65C42.2891 46.65 75.6224 81.3521 75.6224 77.9Z"
      fill="#CBCCC9"
    />
    <path
      d="M69.3724 84.15C72.8245 84.15 75.6224 81.3521 75.6224 77.9V77.3896L42.7995 44.5667L36.0391 51.3271L68.862 84.15H69.3724Z"
      fill="#EFEFEF"
    />
    <path
      d="M75.6211 15.4C75.6211 11.9479 72.8232 9.15002 69.3711 9.15002H68.8607L0.621094 77.3896V77.9C0.621094 81.3521 3.41901 84.15 6.87109 84.15H7.38151L75.6211 15.9104V15.4Z"
      fill="#FFD73D"
    />
    <path
      d="M63.1224 0.81665C51.6161 0.81665 42.2891 10.1437 42.2891 21.65C42.2891 35.8437 58.2599 41.0146 61.7328 63.0062C61.9557 64.4229 61.9724 65.4 63.1224 65.4C64.2724 65.4 64.2891 64.4229 64.512 63.0062C67.9849 41.0146 83.9557 35.8437 83.9557 21.65C83.9557 10.1437 74.6286 0.81665 63.1224 0.81665Z"
      fill="#D73F35"
    />
    <path
      d="M63.1198 14.3584C62.1622 14.3584 61.2141 14.547 60.3294 14.9134C59.4447 15.2799 58.6409 15.817 57.9638 16.4941C57.2867 17.1712 56.7496 17.975 56.3832 18.8597C56.0167 19.7443 55.8281 20.6925 55.8281 21.6501C55.8281 22.6076 56.0167 23.5558 56.3832 24.4405C56.7496 25.3251 57.2867 26.129 57.9638 26.8061C58.6409 27.4831 59.4447 28.0202 60.3294 28.3867C61.2141 28.7531 62.1622 28.9417 63.1198 28.9417C64.0773 28.9417 65.0255 28.7531 65.9102 28.3867C66.7949 28.0202 67.5987 27.4831 68.2758 26.8061C68.9529 26.129 69.49 25.3251 69.8564 24.4405C70.2229 23.5558 70.4115 22.6076 70.4115 21.6501C70.4115 20.6925 70.2229 19.7443 69.8564 18.8597C69.49 17.975 68.9529 17.1712 68.2758 16.4941C67.5987 15.817 66.7949 15.2799 65.9102 14.9134C65.0255 14.547 64.0773 14.3584 63.1198 14.3584Z"
      fill="#752622"
    />
    <path
      d="M18.3159 22.7562V27.1333H24.5534C23.7367 29.7875 21.5221 31.6854 18.3159 31.6854C14.4971 31.6854 11.4034 28.5916 11.4034 24.7729C11.4034 20.9541 14.4992 17.8604 18.3159 17.8604C20.0326 17.8604 21.5992 18.4896 22.8076 19.525L26.0326 16.3021C23.9971 14.4479 21.2888 13.3167 18.3159 13.3167C11.9867 13.3167 6.85547 18.4479 6.85547 24.775C6.85547 31.1021 11.9867 36.2333 18.3159 36.2333C28.3367 36.2333 30.0596 27.2396 29.1159 22.7729L18.3159 22.7562Z"
      fill="white"
    />
  </svg>
)
